import { useTranslation } from "react-i18next";
import { SEARCH_FORM_ID_ROOM_ROOM } from "components/constent";
import { useRoomFilterContext } from "../context";
import { useSubmit } from "./handlers";
import TableRow from "components/rows/tableRow";
import RmNmSelect from "components/select/rm/rmNo";
import BadTypCd from "components/select/rm/badTypCd";
import { regNum } from "components/utils/comm";
import Radio from "components/rows/radio";
import RmTypCd from "components/select/rm/rmTypCd";
import RmOlkCd from "components/select/rm/rmOlkCd";

const SearchForm = () => {
  const { t } = useTranslation();
  const { filters, onChange, onSelect, onReset } = useRoomFilterContext();
  const { onSubmit } = useSubmit();

  return (
    <form id={SEARCH_FORM_ID_ROOM_ROOM} onSubmit={onSubmit} onReset={onReset}>
      <table>
        <tbody>
          <TableRow title={t("row_ttl_rm_inf")}>
            <ul>
              <li>
                <label htmlFor="">{t("lbl_rm_nm")}</label>
                <RmNmSelect
                  isReset={!filters.rmNo}
                  select={(rmNo) => {
                    onSelect("rmNo", rmNo);
                  }}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_rm_typ")}</label>
                <RmTypCd
                  isReset={!filters.rmTypCd}
                  select={(rmTypCd) => onSelect("rmTypCd", rmTypCd)}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_rm_olk")}</label>
                <RmOlkCd
                  isReset={!filters.rmOlkCd}
                  select={(rmOlkCd) => onSelect("rmOlkCd", rmOlkCd)}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_bad_typ")}</label>
                <BadTypCd
                  isReset={!filters.bedTypCd}
                  select={(bedTypCd) => onSelect("bedTypCd", bedTypCd)}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_max_per_ct")}</label>
                <input
                  type="text"
                  name="maxPerCtMax"
                  data-type="C"
                  value={filters.maxPerCtMax}
                  onChange={(e) => {
                    const value = e.currentTarget.value;
                    if (!regNum.test(value)) return;
                    if (regNum.test(value)) {
                      onChange("maxPerCtMax", value);
                    }
                  }}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_min_per_ct")}</label>
                <input
                  type="text"
                  name="maxPerCtMin"
                  data-type="C"
                  onChange={(e) => {
                    const value = e.currentTarget.value;
                    if (!regNum.test(value)) return;
                    if (regNum.test(value)) {
                      onChange("maxPerCtMin", value);
                    }
                  }}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_chld_fee_per_ct")}</label>
                <input
                  type="text"
                  name="chldFreePerCtMax"
                  data-type="C"
                  value={filters.chldFreePerCtMax}
                  onChange={(e) => {
                    const value = e.currentTarget.value;
                    if (!regNum.test(value)) return;
                    if (regNum.test(value)) {
                      onChange("chldFreePerCtMax", value);
                    }
                  }}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_baby_fee_per_ct")}</label>
                <input
                  type="text"
                  name="babyFreePerCtMax"
                  data-type="C"
                  onChange={(e) => {
                    const value = e.currentTarget.value;
                    if (!regNum.test(value)) return;
                    if (regNum.test(value)) {
                      onChange("babyFreePerCtMax", value);
                    }
                  }}
                />
              </li>

              <li>
                <label htmlFor="">{t("lbl_uyn")}</label>
                <div className="flex">
                  <Radio
                    label={t("uyn_y")}
                    id={"Y"}
                    name={"uyn"}
                    checked={filters.uyn === "Y"}
                    onChange={(e) => onChange("uyn", "Y")}
                  />
                  <Radio
                    label={t("uyn_n")}
                    id={"N"}
                    name={"uyn"}
                    checked={filters.uyn === "N"}
                    onChange={(e) => onChange("uyn", "N")}
                  />
                </div>
              </li>
            </ul>
          </TableRow>
        </tbody>
      </table>
    </form>
  );
};

export default SearchForm;

const options = [
  {
    ko: "최대인원수",
    en: "maxPerCtMax",
    value: "maxPerCtMax",
    code: "maxPerCtMax",
  },
  {
    ko: "최소인원수",
    en: "minPerCtMin",
    value: "minPerCtMin",
    code: "minPerCtMin",
  },
  {
    ko: "유아무료최대인원수",
    en: "babyFreePerCtMax",
    value: "babyFreePerCtMax",
    code: "babyFreePerCtMax",
  },
  {
    ko: "유아무료최소인원수",
    en: "babyFreePerCtMin",
    value: "babyFreePerCtMin",
    code: "babyFreePerCtMin",
  },
  {
    ko: "아동무료최대인원수",
    en: "chldFreePerCtMax",
    value: "chldFreePerCtMax",
    code: "chldFreePerCtMax",
  },
  {
    ko: "아동무료최소인원수",
    en: "chldFreePerCtMin",
    value: "chldFreePerCtMin",
    code: "chldFreePerCtMin",
  },
];
